import PropTypes from 'prop-types';
import React from 'react';
// @ts-ignore
import ColorSelector from '../../../gd-components/color/selector/selector';
import FormManager from "../../common/form-manager";
import FormModel from "../../common/form-model-manager";

type Props = {
    form      : FormManager | FormModel
    name      : string
    className?: string

}

export default class ColorPickerFormElement extends React.Component<Props> {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired
    };

    componentDidMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue: string) => {
        this.props.form.onFormComponentValueChange(this.props.name, newValue);
    };

    render() {
        const value = this.props.form.getValue(this.props.name);

        return (
            <ColorSelector className={this.props.className} value={parseInt(value)} onChange={this.onChange} type="default-26"/>
        );
    }
}
